/* eslint-disable */
const state = {
    isGeneralLoading: false,
    isBusLoading: false,
    isBookingLoading: false,
    isLoading: false,
    isOrphanBookingsLoading: false,
    isBookingsForCheckingLoading: false,
};

const mutations = {
    ISLOADING(state, [loadingType, loadingStatus]) {
        if (loadingType === 'default') {
            state.isLoading = loadingStatus;
        }
        if (loadingType === "general") {
            state.isGeneralLoading = loadingStatus;
        }
        if (loadingType === "booking") {
            state.isBookingLoading = loadingStatus;
        }
        if (loadingType === "bus") {
            state.isBusLoading = loadingStatus;
        }
        if ( loadingType === 'orphan_bookings') {
            state.isOrphanBookingsLoading = loadingStatus
        }
        if ( loadingType === 'checking_bookings') {
            state.isBookingsForCheckingLoading = loadingStatus
        }
    }
};

export default {
    state,
    mutations
}